<template>
  <b-modal
    id="scan-menu-modal"
    class="scan-menu-full-screen-modal"
    header-class="scan-menu-modal-header"
    ref="modal"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('scan.menu.modal.try.match')"
    @ok="onValidateClicked"
    centered
    ok-variant="primary">

    <b-form-group
      :label="$t('scan.menu.modal.type.scan')"
      label-for="scan-type-input"
      class="small-text">
      <b-form-select
        id="scan-type-input"
        v-model="scanType"
        @change="onScanTypeChange"
        required>
        <option v-for="type in scanTypes" :value="type.value">
          {{ $t(type.text) }}
        </option>
      </b-form-select>
    </b-form-group>

    <div class="d-flex justify-content-between align-items-center mb-2">
      <label class="mr-3" @click="onPositionToggled">
        {{$t('scan.menu.modal.activate.geoloc')}}
      </label>
      <b-form-checkbox
        size="lg"
        :checked="enabledPosition"
        switch
      ></b-form-checkbox>
    </div>


    <b-form-group
      :label="getInputLabel+'*'"
      class="small-text"
      :invalid-feedback="identifierInput.invalidFeedback"
      label-for="identifier-input">
      <b-form-input
        :state="identifierInput.state"
        id="identifier-input"
        @change="identifierInput.state = null"
        v-model="identifierInput.value"
        :formatter="getInputFormatter"
        required>
      </b-form-input>
    </b-form-group>

    <template #modal-header="{ close }">
      <div  class="scan-menu-modal-header-content step4 w-100">
        <img :src="require(`@/assets/images/b122/img-watcher-right.png`)" class="scan-menu-modal-img" >
        <div class="scan-menu-container h-100">
          <h1 class="page-title ml-4 scan-menu-modal-subtitle" v-html="$t('scan.menu.modal.title')"/>
        </div>
      </div>
    </template>

  </b-modal>
</template>

<script>
import i18n from "../../i18n";
import IdentifierUtils from "../../utils/IdentifierUtils";

export default {
  emits:[
    'onValidateClicked',
  ],

  data() {
    return {
      IdentifierUtils: IdentifierUtils,

      scanType: "LICENCE_PLATE",
      scanTypes: [
        {
          value: "LICENCE_PLATE",
          text: "scan.menu.modal.scan.plate"
        },
        {
          value: "VIN",
          text: "scan.menu.modal.scan.vin"
        },
        {
          value: "BICYCODE",
          text: "scan.menu.modal.scan.bicycode"
        },
        {
          value: "WINDOW_ENGRAVING",
          text: "scan.menu.modal.scan.engraving"
        },
        {
          value: "SERIAL_NUMBER",
          text: "scan.menu.modal.scan.serial"
        },
      ],

      enabledPosition: false,

      identifierInput: {
        state: null,
        invalidFeedback: null,
        value: null,
      }
    };
  },

  computed:{
    getInputLabel(){
      switch (this.scanType) {
        case 'LICENCE_PLATE': return this.$i18n.t('scan.menu.modal.scan.plate')
        case 'VIN': return this.$i18n.t('scan.menu.modal.scan.vin')
        case 'BICYCODE': return this.$i18n.t('scan.menu.modal.scan.bicycode')
        case 'WINDOW_ENGRAVING': return this.$i18n.t('scan.menu.modal.scan.engraving')
        case 'SERIAL_NUMBER': return this.$i18n.t('scan.menu.modal.scan.serial')
      }
    },

    getInputFormatter(){
      switch (this.scanType) {
        case 'LICENCE_PLATE': return IdentifierUtils.formatLicensePlate
        case 'VIN': return IdentifierUtils.formatVin
        case 'BICYCODE': return IdentifierUtils.formatBicycode
        case 'WINDOW_ENGRAVING': return null
        case 'SERIAL_NUMBER': return null
      }
    }
  },

  methods: {
    onScanTypeChange(scanType){
      this.identifierInput.state = null
      this.scanType = scanType
    },

    onPositionToggled(){
      this.enabledPosition = !this.enabledPosition
    },

    validateInput(){
      switch (this.scanType) {
        case 'LICENCE_PLATE': return IdentifierUtils.validateLicensePlate(this.identifierInput.value)
        case 'VIN': return IdentifierUtils.validVinFormat(this.identifierInput.value)
        case 'BICYCODE': return IdentifierUtils.validBicycodeFormat(this.identifierInput.value)
        case 'WINDOW_ENGRAVING': return null
        case 'SERIAL_NUMBER': return null
      }
    },

    onValidateClicked(e) {
      e.preventDefault()
      if(this.identifierInput.value == null || this.identifierInput.value === ""){
        this.identifierInput.state = false
        this.identifierInput.invalidFeedback = this.$i18n.t('MandatoryField')
      }
      else if(this.validateInput() == null){
        this.identifierInput.state = false
        this.identifierInput.invalidFeedback = IdentifierUtils.getIdentifierInvalidFormatFeedback(this.scanType)
      }
      else{
        this.$emit('onValidateClicked', {
          identifierType: this.scanType,
          identifier: this.identifierInput.value,
          enabledPosition: this.enabledPosition
        })
      }
    },
  },
};
</script>

<!-- not scoped car modal --><style>

#scan-menu-modal .modal-header{
  background-color: var(--main-black-light) !important;
  padding-bottom: 0;
}

#scan-menu-modal .modal-content,
#scan-menu-modal .modal-body,
#scan-menu-modal .modal-footer{
  background-color: var(--main-black-dark);
}

.scan-menu-modal-subtitle{
  font-size: 24px;
}

#scan-menu-modal .scan-menu-modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}

.scan-menu-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#scan-menu-modal .modal-text{
  color: var(--main-grey-medium);
}

.scan-menu-modal-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.scan-menu-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  .scan-menu-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .scan-menu-container img {
    order: 2;
    align-self: center;
  }
  .scan-menu-container {
    text-align: center;
  }
}

#scan-menu-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.scan-menu-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.scan-menu-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #scan-menu-modal .modal-content {
    display: flex;
    overflow: auto;
    padding: 10px;
  }
  #scan-menu-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #scan-menu-modal .modal-header {
    padding-top: 0;
  }
  .scan-menu-modal-img {
    margin-top: 20px;
    align-self: end;
  }
  .scan-menu-modal-subtitle {
    margin-top: 6px !important;
    margin-left: 0 !important;
  }
  #scan-menu-modal .modal-content {
    margin: 8px;
  }
  #scan-menu-modal .modal-text, #scan-menu-modal .scan-menu-container {
    padding: 10px;
  }
  #scan-menu-modal .scan-menu-modal-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #scan-menu-modal .modal-content {
    overflow: auto;
  }

  .scan-menu-modal-subtitle{
    font-size: 18px;
  }
  .scan-menu-modal-header-content, #scan-menu-modal .modal-text, .scan-menu-container {
    padding: 2px;

  }
}

</style>



// WEBPACK FOOTER //
// src/views/match/ScanMenuModal.vue